// extracted by mini-css-extract-plugin
export default {"root":"CourseRules_root__wF1RS","table":"CourseRules_table__-GfOV","desp":"CourseRules_desp__RYNR0"};